import * as types from './mutations-type';
import http from '@/request/http';
import store from './index';
import router from '@/router';
import commonApi from '@/request/common/index.js';
import { operationList } from '@c/layout/operation.js';
import { eduList } from '@c/layout/edu.js';
import { schoolList } from '@c/layout/school.js';
import { serviceList } from '@c/layout/service.js';
import { filterLeftNav } from '@/utils/navHelper.js';
import { authAppCodeMap } from '@/common/auth.js';
// 运营端--获取学校列表及默认管理学校
const getSchoolList = ({ commit }) => {
  http.get('/sysSchools/listSchoolsNew').then((res) => {
    if (res.data.status === 200) {
      commit(types.SET_SCHOOLLIST, res.data.message.list);
    }
  });
};
// 获取权限集合
const getAuthcheckPermissionSets = ({ commit }, data) => {
  return new Promise(async(resolve, reject) => {
    let parameter = {};
    // if (![0, 3, 2].includes(data)) {
    //   return resolve()
    // }

    parameter = {
      appCode2PermissionSet: authAppCodeMap
    };
    commonApi.getAuthcheckPermissionSets(parameter).then((res) => {
      if (res.status == 200) {
        let result = {};
        res.message.forEach((item) => {
          result = {
            ...result,
            ...item.result
          };
        });
        commit(types.SET_AUTH_MAP, result);
      }
      resolve();
    });
  });
};

const setSchoolIndex = ({ commit }, data) => {
  commit(types.SET_SCHOOLINDEX, data);
};

// 登出
const doLogout = ({ commit, state }) => {
  localStorage.removeItem('routeList');
  localStorage.removeItem('leftNavList');
  sessionStorage.removeItem('tabsList');
  localStorage.removeItem('htmall_is_login');
  const portOrg = localStorage.getItem('portOrg');
  switch (portOrg) {
    case '0':
      // 平台
      router.push({
        name: 'passport_login',
        query: {
          portOrg: '0'
        }
      });
      break;
    case '1':
      // 教育局
      router.push({
        name: 'passport_login',
        query: {
          portOrg: '1'
        }
      });
      break;
    case '2':
      // 学校
      router.push({
        name: 'passport_login',
        query: {
          portOrg: '2'
        }
      });

      break;
    case '3':
      // 服务
      router.push({
        name: 'passport_login',
        query: {
          portOrg: '3'
        }
      });
      break;
    case '4':
      // 餐饮
      router.push({
        name: 'passport_login',
        query: {
          portOrg: '4'
        }
      });
      break;
    default:
      break;
  }
  localStorage.removeItem('htmall_is_login');
  localStorage.removeItem('file_upload_token');
  localStorage.setItem('oldUserInfo', localStorage.getItem('userInfo'));
  localStorage.removeItem('userInfo');
  localStorage.getItem('schoolId') ? localStorage.removeItem('schoolId') : '';
  localStorage.getItem('courseTableSch')
    ? localStorage.removeItem('courseTableSch')
    : '';
  localStorage.getItem('schoolName')
    ? localStorage.removeItem('schoolName')
    : '';
  localStorage.getItem('areaNameForLeaveListSearch')
    ? localStorage.removeItem('areaNameForLeaveListSearch')
    : '';
  localStorage.getItem('areaCodeForLeaveListSearch')
    ? localStorage.removeItem('areaCodeForLeaveListSearch')
    : '';
  commit(types.SET_STATERESET);
};

// 获取菜单配置
const getMenuList = ({ commit, state }) => {
  return new Promise(async(resolve, reject) => {
    const params = {
      appClient: +localStorage.getItem('portOrg') + 1 // 1 运营端，2学校端 3教育局端 4服务商端
    };
    commonApi.getMenuList(params).then((res) => {
      if (res.status === 200) {
        switch (+localStorage.getItem('portOrg')) {
          case 0:
            // filterLeftNav(operationList)
            const otList = filterLeftNav(operationList);
            console.log('处于运营菜单', otList);
            commit(types.SET_ROUTELIST, otList);
            commit(types.SET_LEFTNAVLIST, otList[0].childList);
            break;
          case 1:
            console.log('处于教育局菜单');
            const eduShow = [...eduList];
            if (state.userInfo.orgId === '614867004922269697') {
              console.log('进入修改了=====');
              eduShow[0].childList = [
                {
                  menuId: '6473904716242955777',
                  domainCode: 'zhxy-cloud',
                  appCode: 'basic430hon',
                  typeCode: '$default',
                  menuName: '数据概览',
                  menuUrl: 'dataStatistics_dataStatistics',
                  menuIcon: '647390423244865536',
                  openWay: 1,
                  accessFlag: 1,
                  parentMenuId: '647390246509494273',
                  sort: 1,
                  status: null,
                  extra: '',
                  childList: []
                }
              ];
            }
            commit(types.SET_ROUTELIST, eduShow);
            commit(types.SET_LEFTNAVLIST, eduShow[0].childList);
            break;
          case 2:
            console.log('处于学校菜单');
            const shList = filterLeftNav(schoolList);
            commit(types.SET_ROUTELIST, shList);
            commit(types.SET_LEFTNAVLIST, shList[0].childList);
            break;
          case 3:
            console.log('处于服务端菜单');
            commit(types.SET_ROUTELIST, serviceList);
            commit(types.SET_LEFTNAVLIST, serviceList[0].childList);
            break;
        }
      }
      resolve();
    });
  });
};

// 运营查机构
const organByOpe = ({ commit, state }, data) => {
  const params = {
    orgId: data.orgId
  };
  commonApi.organByOpe(params).then((resp) => {
    if (resp.status === 200) {
      commit(types.SET_ORGBYOPE, resp.data.message.list);
    }
  });
};
// 运营查学校
const schByOpe = ({ commit, state }, data) => {
  const params = {
    orgId: data.orgId
  };
  commonApi.schByOpe(params).then((resp) => {
    if (resp.status === 200) {
      commit(types.SET_SCHBYOPE, resp.data.message.list);
    }
  });
};

const setColumnsModule = ({ commit }, data) => {
  commit(types.SET_COLUMNS_MODULE, data);
};

const setLeftSwitch = ({ commit }, data) => {
  commit(types.SET_LEFTSWITCH, data);
};
// 设置 浏览记录
const setBrowsingHistoryList = ({ commit }, data) => {
  commit(types.SET_BROWSINGHISTORYLIST, data);
};

const setIfRouterAlive = ({ commit }, data) => {
  commit(types.SET_IFROUTERALIVE, data);
};

export default {
  getSchoolList,
  setSchoolIndex,
  doLogout,
  getMenuList,
  organByOpe,
  schByOpe,
  setColumnsModule,
  setLeftSwitch,
  setBrowsingHistoryList,
  getAuthcheckPermissionSets,
  setIfRouterAlive
};
